import { render } from "./DrawOddsResultCard.vue?vue&type=template&id=762d5e8a&scoped=true"
import script from "./DrawOddsResultCard.vue?vue&type=script&lang=js"
export * from "./DrawOddsResultCard.vue?vue&type=script&lang=js"

import "./DrawOddsResultCard.vue?vue&type=style&index=0&id=762d5e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762d5e8a"],['__file',"DrawOddsResultCard.vue"]])

export default __exports__